var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.isLocaleLoaded)?_c('router-view'):_vm._e(),_c('Error'),_c('portal-target',{attrs:{"name":"modal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }